import React from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { PublicResultsPage } from "./PublicResultsPage";

export function PublicResultsRoute() {
  const { year } = useParams();
  const code = year ? `annual_industry_${year}` : "annual_industry";
  return (
    <Box minH="100vh" bg="gray.50">
      <PublicResultsPage surveyCode={code} />
    </Box>
  );
}
